//Replaces space in an URL with %20
export var replaceSpaceInUrl = function replaceSpaceInUrl(url) {
  return url === null || url === void 0 ? void 0 : url.replaceAll(' ', '%20');
};